export default __webpack_public_path__ + "static/media/Capture.d1897dd0.PNG";